import moment from "moment";
import { useCookies } from "vue3-cookies";
import { reactive } from "vue";
import { setConfigTenant } from "./config";
import { getParamUrl } from "./utilities"

export const { cookies } = useCookies();

export const state = reactive({
  notifications: 0,
  readNotifications: false,
  isUploadedFile: false,
  configTenant: setConfigTenant(),
  hashtagMenu: "#",
});

export const createSession = (login: string) => {
  const currentDate = moment().format("DD-MM-YYYY H:m:s");
  const data_login = JSON.parse(login);
  const { id, name, client } = data_login.user;

  localStorage.setItem("token", data_login.accesstToken);
  localStorage.setItem(
    "userInfo",
    JSON.stringify({
      rol: "CLIENT",
      userId: id,
      name,
      clientId: client.id,
      clientName: client.name,
      confirmDate: client.confirmDate,
      subscription: client.subscription,
      registrationStatus: client.registrationStatus || false,
    })
  );
  localStorage.setItem("expiresIn", data_login.refreshLifetime);
  localStorage.setItem("date", currentDate);
};

export const setRegistrationStatus = () => {
  let userInfo = localStorage.userInfo;
  userInfo = JSON.parse(userInfo);
  userInfo.registrationStatus = true
  localStorage.setItem("userInfo", JSON.stringify(userInfo))
};

export const createSessionAdmin = (login: string) => {
  const currentDate = moment().format("DD-MM-YYYY H:m:s");
  const data_login = JSON.parse(login);
  const { id, name, csUserId } = data_login.csUser;

  localStorage.setItem("token", data_login.accesstToken);
  localStorage.setItem(
    "userInfo",
    JSON.stringify({ rol: "ADMIN", userId: id, name, clientId: id, csUserId })
  );

  localStorage.setItem("expiresIn", data_login.refreshLifetime);
  localStorage.setItem("date", currentDate);
};

export const getRolSession = () => {
  const userInfo = localStorage.userInfo;
  return localStorage.getItem("userInfo") ? JSON.parse(userInfo).rol : "";
};

export const getClietIdSession = () => {
  const userInfo = localStorage.userInfo;
  return localStorage.getItem("userInfo") ? JSON.parse(userInfo).clientId : "";
};

export const getClietIdSessionNAme = () => {
  const userInfo = localStorage.userInfo;
  return localStorage.getItem("userInfo")
    ? JSON.parse(userInfo).clientName
    : "";
};

export const getUserIdSession = () => {
  const userInfo = localStorage.userInfo;
  return localStorage.getItem("userInfo") ? JSON.parse(userInfo).userId : "";
};

export const getUserNameSession = () => {
  const userInfo = localStorage.userInfo;
  return localStorage.getItem("userInfo") ? JSON.parse(userInfo).name : "";
};

export const getConfirmDate = () => {
  const userInfo = localStorage.userInfo;
  return localStorage.getItem("userInfo")
    ? JSON.parse(userInfo).confirmDate
    : "";
};

export const getSubscriptionActive = () => {
  const userInfo = localStorage.userInfo;
  return JSON.parse(userInfo).subscription
    ? JSON.parse(userInfo).subscription.active
    : false;
};

export const getRegistrationStatus = () => {
  const userInfo = localStorage.userInfo;
  return JSON.parse(userInfo).registrationStatus ? JSON.parse(userInfo).registrationStatus : false;
};

export const isWithoutContract = () => {
  return getConfirmDate() === null;
};

export const isWithoutPaymentMethod = () => {
  return !getPaymentId() && !getSubscriptionActive();
};

export const isWithoutPlan = () => {
  return getUserPlanSession() === null;
};

export const getUserPlanSession = () => {
  const userInfo = localStorage.userInfo;
  return localStorage.getItem("userInfo")
    ? JSON.parse(userInfo).subscription
    : "";
};

export const withoutContract = () => {

  if (!getRegistrationStatus()) {
    return goRoute("/client-area/complete-profile");
  }

  if (isWithoutContract() || isWithoutPaymentMethod() || isWithoutPlan()) {
    return goRoute("/client-area/new-subscription");
  }
};

export const isExpiredContract = () => {
  if (!isWithoutContract() && isFree() && getDiffDate() >= 90) {
    goRoute("/client-area/new-subscription");
  }
};

export const getToken = () => {
  const token = localStorage.token;
  return token;
};

export const isSessionExpired = () => {
  if (!localStorage.date) {
    return true;
  } else {
    const currentDate = moment().format("DD-MM-YYYY H:m:s");
    const sessionDate = localStorage.date;
    const expiresIn = localStorage.expiresIn;
    const sesionExpires = moment(sessionDate).add(
      parseInt(expiresIn),
      "minutes"
    );
    const sessionExpired = moment(currentDate).isAfter(sesionExpires);

    if (sessionExpired) {
      localStorage.clear();
      getSubDomain();
      return true;
    }
  }
};

export const logout = (isManual: Boolean = false) => {
  if (localStorage.date) {
    const storage_infoTenant_temp = getInfoTenant();
    const storage_tenant_temp = getTenant();
    const storage_domain_temp = getTenantDomain();

    localStorage.clear();
    getSubDomain();

    goRoute(!isManual ? "/login" : "/");
    if (!isManual) {
      location.reload();
    }

    localStorage.setItem("InfoTenant", storage_infoTenant_temp);
    localStorage.setItem("tenant", storage_tenant_temp);
    localStorage.setItem("subDomain", storage_domain_temp);
  }
};

export const goRoute = (newRoute: string) => {
  window.location.href = newRoute;
};

export const routerRedirect = async () => {
  const param = getParamUrl("code");
  const param3 = getParamUrl("RETURNMAC");

  if (param !== null && !isSessionExpired()) {
    const param2 = getParamUrl("event");
    goRoute(`/sign/${param}/${param2}`);
  } else if (param3 !== null && !isSessionExpired()) {
    goRoute(`/client-area/payment/${param3}`);
  } else if (param !== null) {
    goRoute(`/auth/${param}`);
  }
  return false;
};

export const getFormatDateComplete = (date: any, formatType: number) => {
  moment.locale("es");
  let dateFormat = date;
  if (formatType === 1) {
    dateFormat = moment(date).format("MMM DD, YYYY");
  } else if (formatType === 2) {
    dateFormat = moment(date).format("YYYY-MM-DD");
    dateFormat = dateFormat + "T15:20:52.219Z";
  } else if (formatType === 3) {
    dateFormat = moment(date).format("DD-MM-YYYY");
  } else if (formatType === 4) {
    dateFormat = moment(date).format("DD MMM YYYY");
  } else if (formatType === 5) {
    dateFormat = moment(date).format("DD/MM/YYYY");
  } else if (formatType === 6) {
    dateFormat = moment(date).format("MMM DD, YYYY - H:m");
  } else if (formatType === 7) {
    dateFormat = moment(date).format("MMM");
  } else if (formatType === 8) {
    dateFormat = moment(date).format("DD");
  } else if (formatType === 8) {
    dateFormat = moment(date).format("YYYY");
  }
  return dateFormat;
};

export const getCurrentDate = () => {
  return moment().format("MM-DD-YYYY");
};

export const getDateRest = (date: any, cant: number) => {
  const date_ = date; 
  return moment(date_).format("MM-DD-YYYY");
};

export const getDateCompare = (date1: any, date2: any) => {
  const date_ = moment(date1).isAfter(moment(date2));
  return date_;
};

export const formatAmount = (amount: any) => {
  const currentAmount = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(amount);
  return currentAmount;
};

export function calculatePercent(total: number, value: number) {
  if (total === 0 || value === 0) return 0;
  if (total === value) return 100;
  const result: number = Math.round((value * 100) / total);
  if (result > 100) {
    return 100;
  } else {
    return result;
  }
}

export const isDateNotExpired = (date: any) => {
  const expired_year = moment().isSame(moment(date), "year");
  const expired_month = moment().isSame(moment(date), "month");
  const expired_day = moment().isSame(moment(date), "day");

  return expired_year && expired_month && expired_day;
};

export const isFreePlan = (plan: string) => {
  const index = plan.indexOf(" Free");
  return index >= 0;
};

export const isPremiumPlan = (plan: string) => {
  const index = plan.indexOf("Axactor Subscription");
  return index >= 0;
};

export const isAutonomoPlan = (plan: string) => {
  const index = plan.indexOf("Autónomo");
  return index >= 0;
};

export const isPymesPlan = (plan: string) => {
  const index = plan.indexOf("Pymes");
  return index >= 0;
};

export const printPlanName = (plan: string) => {
  if (isPremiumPlan(plan)) return 'Plan Premium';
  if (isFreePlan(plan)) return 'Plan Básico';

  const index = plan.indexOf("Plan");
  return (index >= 0 ? plan : 'Plan' + plan);
};

export const isFree = () => {
  let name = "";
  if (
    getRolSession() === "CLIENT" &&
    !isWithoutContract() &&
    getUserPlanSession() !== null
  ) {
    name = getUserPlanSession().name;
  }
  return isFreePlan(name);
};

export const getDiffDate = () => {
  const dateInit = getConfirmDate();
  const diff = moment().diff(moment(dateInit).format("MM-DD-YYYY"), "days");
  let days = 0;

  if (diff === 83 || diff === 89 || diff >= 90) {
    days = diff;
  }
  return days;
};

export const notAccess = () => {
  if (!isFree() && !isWithoutContract()) {
    goRoute("/");
  }
};

export const getSubDomain = () => {
  if (!localStorage.getItem("subDomain")) {
    const currentUrl = window.location.host;
    const index = currentUrl.indexOf("trecupera-pre.com");

    const currentSubDomain = window.location.host;
    const domain =
      isLocalDomain() || index >= 0 || isDevOrPreDomain()
        ? index >= 0
          ? "www." + currentSubDomain
          : "wivai." + currentSubDomain
        : isProDomain()
          ? "www." + currentSubDomain
          : currentSubDomain; 
    const subDomain = domain.split(".");

    localStorage.setItem("subDomain", subDomain[0]);
  }
};

export const setDomain = (domain: string) => {
  localStorage.setItem("subDomain", domain);
  location.reload();
};

export const isLocalDomain = () => {
  const currentUrl = window.location.host;
  const index_local = currentUrl.indexOf("localhost");
  return index_local >= 0;
};

export const isDevOrPreDomain = () => {
  const currentUrl = window.location.host;
  const index = currentUrl.indexOf("trecupera-pre.com");
  return index >= 0;
};

export const isProDomain = () => {
  const currentUrl = window.location.host;
  const index = currentUrl.indexOf("trecupera.com");
  return index >= 0;
};

export const setTenant = (tenant: any) => {
  localStorage.setItem("tenant", JSON.stringify(tenant));
};

export const getTenant = () => {
  const tenatInfo = localStorage.tenant;
  return localStorage.getItem("tenant") ? tenatInfo : "";
};

export const setInfoTenant = (info: any) => {
  localStorage.setItem("InfoTenant", JSON.stringify(info));
};

export const getInfoTenant = () => {
  const tenatInfo = localStorage.InfoTenant;
  return localStorage.getItem("InfoTenant") ? tenatInfo : "";
};

export const getTenantId = () => {
  const tenatInfo = localStorage.InfoTenant;
  return localStorage.getItem("InfoTenant") ? JSON.parse(tenatInfo).id : "";
};

export const getTenantName = () => {
  const tenatInfo = localStorage.InfoTenant;
  return localStorage.getItem("InfoTenant") ? JSON.parse(tenatInfo).name : "";
};

export const getTenantBankAccountCountryPrefix = () => {
  const tenatInfo = localStorage.InfoTenant;
  return localStorage.getItem("InfoTenant")
    ? JSON.parse(tenatInfo).bankAccountCountryPrefix
    : "";
};

export const getTenantBankAccountPrefix = () => {
  const tenatInfo = localStorage.InfoTenant;
  return localStorage.getItem("InfoTenant")
    ? JSON.parse(tenatInfo).bankAccountPrefix
    : "";
};

export const getTenantDomain = () => {
  const tenatInfo = localStorage.subDomain;
  return localStorage.getItem("subDomain") ? tenatInfo : "";
};

export const getPaymentId = () => {
  const userInfo = localStorage.paymentId;
  return localStorage.getItem("paymentId");
};

export const getPaymentMethodAdded = () => {
  const userInfo = localStorage.paymentMethodAdded;
  return localStorage.getItem("paymentMethodAdded");
};

export const getTenantConditions = () => {
  const tenatInfo = localStorage.InfoTenant;
  return localStorage.getItem("InfoTenant")
    ? JSON.parse(tenatInfo).conditions
    : "";
};

export const getTenantCookiesPolicy = () => {
  const tenatInfo = localStorage.InfoTenant;
  return localStorage.getItem("InfoTenant")
    ? JSON.parse(tenatInfo).cookiesPolicy
    : "";
};

export const getTenantLegalInformation = () => {
  const tenatInfo = localStorage.InfoTenant;
  return localStorage.getItem("InfoTenant")
    ? JSON.parse(tenatInfo).legalInformation
    : "";
};

export const getTenantPrivacyPolicy = () => {
  const tenatInfo = localStorage.InfoTenant;
  return localStorage.getItem("InfoTenant")
    ? JSON.parse(tenatInfo).privacyPolicy
    : "";
};

export const setHeadScript = (currentScript: any) => {
  if (currentScript === "marketing") {
    //@/assets/dinamicScripts/linkedinPartner.js
    createBlockScript(
      "beforeCloseHead",
      "linkedin_partner",
      "",
      contentScriptLinkedinPartner()
    );

    //@/assets/dinamicScripts/linkedin.js
    createBlockScript(
      "beforeCloseHead",
      "linkedin",
      "Linkedin",
      contentScriptLinkedin()
    );
    //No Script Linkedin
    createBlockNoScript(
      "beforeCloseHead",
      "no_script_linkedin",
      contentNoScriptLinkedin()
    );
    //All pages
    createLineScript(
      "afterOpenHead",
      "https://www.googletagmanager.com/gtag/js?id=AW-11053770120",
      currentScript + "_google_tag",
      "Google tag (gtag.js)",
      true
    );
    //@/assets/dinamicScripts/googleAdwordsLayer.js
    createBlockScript(
      "beforeCloseHead",
      "google_adwords_layer",
      "Google Adwords Layer",
      contentScriptGoogleAdwordsLayer()
    );
  }

  ///assets/dinamicScripts/matomo.js
  if (currentScript === "stadistyc") {
    createBlockScript(
      "afterOpenHead",
      "matomo",
      "Matomo",
      contentScriptMatomo()
    );
  }
};

export const createLineScript = (
  position: string,
  sourceScript: string,
  id: string,
  comment: string,
  async: boolean = false
) => {
  if (document.getElementById(id)) {
    return;
  }
  const src = sourceScript;
  const script = document.createElement("script");
  if (async) {
    script.async = true;
  }
  script.setAttribute("src", src);
  script.setAttribute("type", "text/javascript");
  script.setAttribute("id", id);

  if (position === "afterOpenHead") {
    createComment("afterOpenHead", comment);
    document.head.insertBefore(script, document.head.firstElementChild);
  } else if (position === "beforeCloseHead") {
    createComment("beforeCloseHead", comment);
    document.head.appendChild(script);
  }
};

export const createComment = (position: string, currentComment: any) => {
  const comment = document.createComment(currentComment);
  if (position === "afterOpenHead") {
    document.head.insertBefore(comment, document.head.firstElementChild);
  } else {
    document.head.appendChild(comment);
  }
};

export const createBlockScript = (
  position: string,
  id: string,
  comment: string,
  content: string
) => {
  if (document.getElementById(id)) {
    return;
  }
  const script = document.createElement("script");
  script.setAttribute("id", id);
  script.setAttribute("type", "text/javascript");

  script.innerHTML = content;

  if (position === "afterOpenHead") {
    createComment("afterOpenHead", comment);
    document.head.insertBefore(script, document.head.firstElementChild);
  } else if (position === "beforeCloseHead") {
    createComment("beforeCloseHead", comment);
    document.head.appendChild(script);
  }
};

export const createBlockNoScript = (
  position: string,
  id: string,
  content: string
) => {
  if (document.getElementById(id)) {
    return;
  }
  const script = document.createElement("noscript");
  script.setAttribute("id", id);
  script.innerHTML = content;

  if (position === "afterOpenHead") {
    document.head.insertBefore(script, document.head.firstElementChild);
  } else if (position === "beforeCloseHead") {
    document.head.appendChild(script);
  }
};

export const contentScriptMatomo = () => {
  let content = "";
  content += "var _mtm = window._mtm = window._mtm || []; ";
  content +=
    "_mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});";
  content +=
    "var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];";
  content += "g.async=true; ";
  content +=
    "g.src='https://cdn.matomo.cloud/axactor.matomo.cloud/container_GO0HWj2z.js';";
  content += "s.parentNode.insertBefore(g,s);";

  return content;
};

export const contentScriptLinkedin = () => {
  let content = "";
  content += "(function(l) {";
  content +=
    "if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};";
  content += "window.lintrk.q=[]}";
  content += 'var s = document.getElementsByTagName("script")[0];';
  content += 'var b = document.createElement("script");';
  content += 'b.type = "text/javascript";b.async = true;';
  content +=
    'b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";';
  content += "s.parentNode.insertBefore(b, s);})(window.lintrk);";

  return content;
};

export const contentScriptLinkedinPartner = () => {
  let content = "";

  content += '_linkedin_partner_id = "4583722";';
  content += "window._linkedin_data_partner_ids = ";
  content += "window._linkedin_data_partner_ids || [];";
  content += "window._linkedin_data_partner_ids.push(_linkedin_partner_id);";

  return content;
};

export const contentScriptGoogleAdwordsLayer = () => {
  let content = "";

  content += "window.dataLayer = window.dataLayer || [];";
  content += "function gtag() {";
  content += "  dataLayer.push(arguments);";
  content += "}";
  content += 'gtag("js", new Date());';
  content += 'gtag("config", "AW-11053770120");';

  return content;
};

export const contentNoScriptLinkedin = () => {
  let content = "";

  content +=
    '<img height="1" width="1" style="display:none;" alt="" src=https://px.ads.linkedin.com/collect/?pid=4583722&fmt=gif />';

  return content;
};

export const setScriptsHeadersByCookies = () => {
  const currentCookieScript = getCookies("CookieInformationConsent");
  if (currentCookieScript) {
    const cookiesCat = currentCookieScript.split(",");

    cookiesCat.map((itemCookie) => {
      if (itemCookie === "cookie_cat_marketing") {
        setHeadScript("marketing");
      }
      if (itemCookie === "cookie_cat_statistic") {
        setHeadScript("stadistyc");
      }
    });
  }
};

export const getCookies = (cookieName: any) => {
  if (cookies.get(cookieName)) {
    return cookies.get(cookieName);
  }
};
